<!-- 首页// 碳排放/标煤  -->
<template>
    <div class="box">
      <Title :text="electricity.CarbonEmission.Title[0]" :engText="electricity.CarbonEmission.Title[1]"></Title>
      <div class="content">
          <div class="content-title">
            <div class="a">
              [
              <div :class="`${active === 1 ? 'active' : ''}`" @click="fn1(1)">本日</div>
              <div :class="`${active === 2 ? 'active' : ''}`" @click="fn1(2)">本月</div>
              <div :class="`${active === 3 ? 'active' : ''}`" @click="fn1(3)">本年</div>
              ]
            </div>
          </div>
          <div class="val-box">
              <div class="icon"></div>
              <div>
                  <div class="attribute-name">电（t/tce）</div>
                  <div class="attribute-val">{{electricity.CarbonEmission.data.val}}</div>
              </div>
          </div>
          <div class="mcda">
          <div class="left">
            <div class="e">
              <!-- echarts -->
            </div>
            <div>同比</div>
            <div class="shuxingVal">
              <div class="white scale">100%</div>
              <div class="add"></div>
            </div>
          </div>
          <div class="center"></div>
          <div class="right">
            <div class="e">
              <!-- echarts -->
            </div>
            <div>环比</div>
            <div class="shuxingVal">
              <div class="white scale">100%</div>
              <div class="reduce"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Title from '../../components/title/index.vue';
  import { mapState,mapActions } from 'pinia' //引入映射函数
  import useStore from '@/store/index' //引入store
  export default {
    components: {
      Title,
    },
    computed:{
      ...mapState(useStore,['electricity']) 
    },
    data () {
      return {
        // active 1:日，2:月，3:年
        active:1,
      }
    },
    mounted () {
    },
    methods: {
      fn1(i){
        this.active = i;
      }
    }
  }
  </script>
  
  <style scoped>
  .box{
     width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .content{
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .content-title{
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: column;
  }
  .content-title .a{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-title .a > div{
    margin: 0px 10px;
    font-size: 12px;
    cursor: pointer;
  }
  .active{
    text-shadow: 0px 4px 5px #488dff;
  }
  .content .val-box{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
  }
  .content .val-box .icon{
    width: 152px;
    height: 100px;
    background: url('@/assets/img/排放3D.png') no-repeat;
    background-size: 100% 100%;
    margin-right: 25px;
  }
  .content .val-box >div:nth-child(2){
      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .content .val-box .attribute-name{
      font-size: 12px;
  }
  .content .val-box .attribute-val{
      font-size: 16px;
      color:#fff;
      font-weight: 700;
  }
  .content .mcda {
    height: 66px;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
  }
  .content > div .left,
  .content > div .right {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
  }
  .content .mcda .left{
    display: flex;
    flex-direction: initial;
    align-items: center;
  }
  .content .mcda .left .e {
      width: 65px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: url('@/assets/img/a1.png') no-repeat;
    background-size: 80% 80%;
    background-position: center center;
  }
  .content .mcda .center{
      width: 1px;
      border-left: 1px dashed #5a6b8b;
  }
  .content .mcda .right{
    flex-direction: initial;
    align-items: center;
  
  }
  .content .mcda .right .e{
      width: 65px;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: url('@/assets/img/a2.png') no-repeat;
    background-size: 80% 80%;
    background-position: center center;
  }
  .content .mcda .shuxingVal {
    display: flex;
    align-items: center;
    margin-left: 6px;
  }
  .white{
      color: white;
  }
  </style>